module.exports = __webpack_public_path__ + "img/facade-contemporary-single.3ddde90e.jpeg";